// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import { CheckboxGroupStyle } from "@insite/mobius/CheckboxGroup";
import { css } from "styled-components";

filtersAccordionStyles.accordion = {
    css: css`
        dt,
        dd {
            border-right: 0;
            border-left: 0;
        }
        dt:last-of-type,
        dd:last-of-type {
            border-bottom: 0;
        }
        dd {
            padding: 9px 12px 8px;
            ${CheckboxGroupStyle} {
                legend {
                    display: none;
                }
            }
        }
    `,
};
